import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ContentShell from "components/ContentShell";
import BulkUploadPanel from "components/bulkUpload/BulkUploadPanel";
import configData from "config/config.json";
import {
  bulkUpdateLeagueConfig,
  downloadLeagueBulkTemplate,
  validateLeagueBulkUpload,
} from "services/leagueServices";

const BulkUploadLeagues = () => {
  const navigate = useNavigate();

  return (
    <ContentShell title="Bulk Upload Leagues &amp; Milestones">
      <Box sx={{ maxWidth: 980, mx: "auto", py: 1 }}>
        <BulkUploadPanel
          entityLabel="division"
          actionVerb="Update"
          previewSheet="Leagues"
          templateNote={
            <>
              The template has a <b>Leagues</b> sheet (one row per division) and
              a <b>Milestones</b> sheet (one row per milestone, linked by{" "}
              <b>League Number</b>). It has one example row per sheet: replace
              the <b>&lt;LEAGUE_NUMBER&gt;</b>, <b>&lt;PASTE_PACK_ID&gt;</b> and{" "}
              <b>&lt;PASTE_IMAGE_ID&gt;</b> placeholders and add a row for each
              division and milestone you want to change. Leave the{" "}
              <b>Leagues</b> sheet with no rows to update only milestones. A
              division's milestones are replaced by exactly the rows you list
              for it, so include all of them. Add translations
              in the <b>Description [iso]</b> columns. Reference a milestone
              reward image by its <b>Image ID</b> from the Image Repository. The
              highest Milestone Number in a division is always its reserved
              promotion/champion milestone.
            </>
          }
          onDownloadTemplate={downloadLeagueBulkTemplate}
          onValidate={validateLeagueBulkUpload}
          onCommit={bulkUpdateLeagueConfig}
          onViewList={() => navigate(configData.routes.leagues.leagues)}
        />
      </Box>
    </ContentShell>
  );
};

export default BulkUploadLeagues;
